import appGlobalScript from '/package/web-app/src/global/app.ts';
export const globalScripts = appGlobalScript;
